import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {ResponseMessageModel} from './shared/models/response-message.model';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseURL = 'https://ec2-3-88-234-113.compute-1.amazonaws.com:5000/';
  constructor(private http: HttpClient) { }


  pretrain(count): Observable<ResponseMessageModel> {
    console.log('pretrain ' + this.baseURL + 'pretrain/' + count);
    return this.http.get<ResponseMessageModel>(this.baseURL + 'pretrain/' + count).pipe(
      retry(2),
      catchError(this.handleError)
    );
  }


  makePrediction(count): Observable<ResponseMessageModel> {
    console.log('makePrediction ' + this.baseURL + 'predict/' + count);
    return this.http.get<ResponseMessageModel>(this.baseURL + 'predict/' + count).pipe(
      retry(2),
      catchError(this.handleError)
    );
  }


  learnFromAll(): Observable<ResponseMessageModel> {
    console.log('learnFromAll ' + this.baseURL + 'learn-from-all');
    return this.http.get<ResponseMessageModel>(this.baseURL + 'learn-from-all').pipe(
      retry(2),
      catchError(this.handleError)
    );
  }


  learn(id): Observable<ResponseMessageModel> {
    console.log('learn ' + this.baseURL + 'learn');
    return this.http.get<ResponseMessageModel>(this.baseURL + 'learn/' + id).pipe(
      retry(2),
      catchError(this.handleError)
    );
  }


  testWithOtherClassifier(model): Observable<ResponseMessageModel> {
    console.log('testWithOtherClassifier ' + this.baseURL + 'test-with-other-classifier');
    return this.http.get<ResponseMessageModel>(this.baseURL + 'test-with-other-classifier/' + model)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);

      if (error.status === 0 ){

        const a = document.createElement('a');
        a.target = '_blank';
        a.href = 'https://ec2-3-88-234-113.compute-1.amazonaws.com:5000/';

        if (window.confirm('Please allow access to the redirecting site due to the server uses a self-signed certificate. \n' +
          'Click \"Advanced > Proceed Anyway\" and then, try again this function!! \n\n ' +
          '(You may have to allow the popup blocker as well)'))
        {
          a.click();
        }

      }
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }
}
